<template>
    <div>
        <Form ref="formInline" inline  :label-width="150" label-position="left">
            <Row>
                <Col :lg="8" :xs="13">
                  <FormItem label="加班政策代码：">
                        <Select v-model="otCtrl.otPolicyCdpj" clearable style="width:300px">
                            <Option v-for="(item, i) in otZcList" :key="i" :value="item.showotid" >{{item.showotid}}</Option>
                        </Select>
                  </FormItem>
                </Col>
                <Col :lg="8" :xs="13">
                  <FormItem label="加班政策名称：">
                      <Input  v-model="otCtrl.otPolicyNm "/>
                  </FormItem>
                </Col>
                <Button  @click="pageInfo.pageNo=1,total=0,getData()"><!-- 检索 -->{{$t('Search')}}</Button>
              </Row>
             
          </Form>
       
        <Form>
            <Table  stripe border :columns="columns" :loading="loading" :data="dataTable">
                <template slot="slot" slot-scope="{ row }">
                    <Button type="warning"  size="small" @click="openPop(row)">编辑</Button>
                    <Button type="error"  size="small" @click="deleteInfo(row)">删除</Button>
                </template>
            </Table>
            <Page  :total="total" style="float:left;margin-top: 15px;" @on-change="pageChange" />
            <div class="addButton">
                <Button type="primary" icon="md-add"  @click="addData()">新增</Button>
            </div>
        </Form>
        <Modal v-model="popShow" width="80%" :title="itemTitle==1 ? '新增' : '编辑'"> 
            <Form :modal="formItem" ref="formItem"  :label-width="185" label-position="left" >
                  <Row>
                    <Col span="10" offset="1">
                      <FormItem label="加班政策代码：">
                          <Select :disabled="itemTitle!=1" v-model="formItem.otPolicyCdpj" clearable @on-change="formItem.otType='',formItem.cDescription='',formItem.eDescription='',getOtLabel()">
                            <Option v-for="(item, i) in otZcList" :key="i" :value="item.showotid" >{{item.showotid}}</Option>
                        </Select>
                      </FormItem>
                    </Col>
                    <Col span="10" offset="2">
                      <FormItem label="加班政策名称：">
                          <Input disabled  v-model="formItem.otPolicyNm "/>
                      </FormItem>
                    </Col>
                  </Row>
                  <Row>
                    <Col span="10" offset="1">
                      <FormItem label="加班类型：">
                          <Select v-model="formItem.otType" clearable @on-change="formItem.cDescription='',formItem.eDescription='',getCEName()">
                              <Option v-for="(item, i) in otTypeList" :key="i" :value="item.code" >{{item.code}}</Option>
                          </Select>
                      </FormItem>
                    </Col>
                    <Col span="10" offset="2">
                      <FormItem label="加班展示类型：">
                          <Input   v-model="formItem.dispOtType"/>
                      </FormItem>
                    </Col>
                  </Row>
                  <Row>
                    <Col span="10" offset="1">
                      <FormItem label="加班名称(中文)：">
                        <Input disabled  v-model="formItem.cDescription "/>
                      </FormItem>
                    </Col>
                    <Col span="10" offset="2">
                      <FormItem label="加班名称(英文)：">
                        <Input  disabled v-model="formItem.eDescription "/>
                      </FormItem>
                    </Col>
                  </Row>
                  <Row>
                    <Col span="10" offset="1">
                      <FormItem label="加班显示名称(中文)：">
                        <Input  v-model="formItem.dispCDescription "/>
                      </FormItem>
                    </Col>
                    <Col span="10" offset="2">
                      <FormItem label="加班显示名称(英文)：">
                        <Input  v-model="formItem.dispEDescription "/>
                      </FormItem>
                    </Col>
                  </Row>
                  <Row>
                    <Col span="5" offset="1">
                        <FormItem label="最小申请数：" >
                        <InputNumber  style="width: 70px" :min="0"   v-model="formItem.minVal" /> 小时
                        </FormItem>
                    </Col>
                    <Col span="5" offset="1">
                        <FormItem label="最小申请单位：" >
                        <InputNumber  style="width: 70px" :min="0"   v-model="formItem.minUnitVal" />  小时
                        </FormItem>
                    </Col>
                    <Col span="10" offset="1">
                        <FormItem label="考勤体系名称：">
                            <Input disabled  v-model="formItem.atsNm "/>
                        </FormItem>
                      </Col>
                </Row>
                <Row>
                    <Col span="22" offset="1">
                      <FormItem label="备注：" >
                            <Input type="textarea" :autosize="{minRows: 5,maxRows: 5}"  v-model="formItem.remark" placeholder=""> </Input>
                      </FormItem>
                    </Col>
                </Row>
            </Form>
            <Spin size="large" fix v-if="spinShow"></Spin>
            <div slot="footer"  >
                <Button @click="cancelLeaveData">取消</Button>
                <Button @click="saveLeaveData">保存</Button>
            </div>
        </Modal>
    </div>
</template>
<script>
import axios from 'axios'

export default {
    data(){
        return{
            pageInfo: {
                pageNo: 1, //页码
                pageSize: 10, //每页数据条数
            },
            total:0,
            rsztList:[],
            otZcList:[],
            itemTitle:0,
            spinShow:false,
            loading:false,
            dataTable:[],
            otCtrl:{},
            otTypeList:[],
            popShow:false,
            formItem:{
                match_emp_type1:[]
            },
            xbList:[
            {
                    name1: '男',
                    code: 'M'
                },
                {
                    name1: '女',
                    code: 'F'
                },
                {
                    name1: '所有',
                    code: 'ALL'
                },
            ],
            xjdwList: [
                {
                    name1: '日',
                    code: 'D'
                },
                {
                    name1: '时',
                    code: 'H'
                },
            ],
            hyzkList: [
                {
                    name1: '已婚',
                    code: 'M'
                },
                {
                    name1: '未婚',
                    code: 'S'
                },
                {
                    name1: '所有',
                    code: 'ALL'
                },
            ],
            columns:[
            {
                title: '加班政策(代码)',
                key: 'showotid',
                align: 'center'
            },
            {
                title: '加班政策名称',
                key: 'otPolicyNm',
                align: 'center'
            },
            {
                title: '加班类型',
                key: 'otType',
                align: "center"
            },
            {
                title: '加班展示名称(中文)',
                key: 'dispCDescription',
                align: "center"
            },
            {
                title: '考勤体系名称',
                key: "atsNm",
                align: "center"

            },
            {
                title: '最小申请数',
                key: "minVal",
                align: "center",
            },
            {
                title: '最小申请单位',
                key: "minUnitVal",
                align: "center",
            },
            {
                title: '编辑',
                align: "center",
                slot:"slot"
            },
            ],
        }
    },
    created(){
        this.getData()
        this.getLabel()
    },
    methods:{
        getCEName(){
            
            this.otTypeList.map((item) => {
                if(this.formItem.otType == item.code){
                    this.$set(this.formItem,'cDescription',item.c_name)
                    this.$set(this.formItem,'eDescription',item.e_name)
                }
            })
            this.$forceUpdate()
        },
        pageChange(val){
            this.pageInfo.pageNo=val
            this.getData()
        },
        getData(){
            this.loading=true
            this.otZcList.map((item)=>{
                if(this.otCtrl.otPolicyCdpj == item.showotid){
                    this.otCtrl.otPolicyCd = item.otid,
                    this.otCtrl.atsId = item.atsid
                }
            })
            let json={
                otPolicyCd :this.otCtrl.otPolicyCd,
                otPolicyNm:this.otCtrl.otPolicyNm,
                atsId:this.otCtrl.atsId,
                pageNo:this.pageInfo.pageNo,
                pageSize:this.pageInfo.pageSize
            }
            console.log(json)
            axios.post('/OtCtrl/selectOtCtrlData',json).then(res => {
                this.loading=false
                if(res) {
                    this.dataTable=res.data
                    this.total=Number(res.pageInfo.total)
                }
            })
        },
        openPop(row){
            this.spinShow=true
            this.itemTitle=0,
            this.popShow=true
            this.formItem=JSON.parse(JSON.stringify(row))
            this.formItem.otPolicyCdpj=row.showotid
            this.getOtLabel()
        },
        addData(){
            this.formItem={
                minVal:null,
                minUnitVal:null
            },
            this.itemTitle=1,
            this.popShow=true
        },
        getLabel(){
            axios.post('/OtCtrl/selectOtLabel',{}).then(res => {
               this.otZcList = res.otZcList
            })
        },
        getOtLabel(){
            this.formItem.otPolicyCd=''
            this.formItem.otPolicyNm=''
            this.formItem.atsNm=''
            this.otZcList.map((item)=>{
                if(this.formItem.otPolicyCdpj == item.showotid){
                    this.formItem.otPolicyCd = item.otid
                    this.formItem.atsId = item.atsid
                    this.formItem.atsNm = item.atsnm
                    this.formItem.otPolicyNm = item.c_name
                }
            })
            let obj={
                otPolicyCd : this.formItem.otPolicyCd,
                atsId : this.formItem.atsId
            }
            axios.post('/OtCtrl/selectOtZcOtLabel',obj).then(res => {
                if(res){
                    this.otTypeList = res
                }else{
                    this.otTypeList=[]
                }
                this.spinShow=false
            })
        },
        saveLeaveData(){
            this.$Modal.confirm({
                title: this.$notice('sureSave'),
                onOk: () => {
                  this.submitSave()
                }
            })
        },
        submitSave(){
             // 新增编辑接口不同
             if(this.itemTitle == 1){
                 let obj={
                     ...this.formItem
                 }
                 axios.post('/OtCtrl/insertOtCtrlData',obj).then(res => {
                    if(res){
                        this.popShow=false;
                        this.$Message.success("新增成功")
                        this.getData()
                        
                    }
                 })
            }else{
                let obj={
                     ...this.formItem
                 }
                 axios.post('/OtCtrl/updateOtCtrlData',obj).then(res => {
                    if(res){
                        this.popShow=false;
                        this.$Message.success("修改成功")
                        this.getData()
                    }
                 })
            }
        },
        cancelLeaveData(){
            this.popShow=false
        },
        deleteInfo(row){
            this.$Modal.confirm({
                title: this.$notice('deletion'),
                onOk: () => {
                    let obj={ 
                        id:row.id
                    }
                axios.post('/OtCtrl/deleteOtCtrlData',obj).then(res => {
                    if(res){
                        this.$Message.success("删除成功")
                        this.getData()
                    }
                })
                }
            })
        }
    }
    }
</script>
<style lang="scss" scoped>
.addButton{
    margin-top: 20px;
    text-align: right;
    padding-bottom: 15px;
  }
</style>


// WEBPACK FOOTER //
// src/components/process/SystemSettings/OtCtrlSet.vue